var map = {
	"./i18n/en-us.json": [
		38659,
		"libs_cl-ui_src_lib_area-header_i18n_en-us_json"
	],
	"./i18n/es-es.json": [
		16339,
		"libs_cl-ui_src_lib_area-header_i18n_es-es_json"
	],
	"./i18n/pt-br.json": [
		85417,
		"libs_cl-ui_src_lib_area-header_i18n_pt-br_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 46601;
module.exports = webpackAsyncContext;